/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type MutationResult = "failure" | "skipped" | "success" | "%future added value";
export type obligationsDeleteObligationEventMutationVariables = {
    readonly obligation_id: string;
    readonly event_id: string;
};
export type obligationsDeleteObligationEventMutationResponse = {
    readonly deleteObligationEvent: ({
        readonly event_template_id: string | null;
        readonly result: MutationResult;
        readonly description: string | null;
        readonly errors: ReadonlyArray<string | null> | null;
    }) | null;
};
export type obligationsDeleteObligationEventMutation = {
    readonly response: obligationsDeleteObligationEventMutationResponse;
    readonly variables: obligationsDeleteObligationEventMutationVariables;
};



/*
mutation obligationsDeleteObligationEventMutation(
  $obligation_id: String!
  $event_id: String!
) {
  deleteObligationEvent(obligation_id: $obligation_id, event_id: $event_id) {
    event_template_id
    result
    description
    errors
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "obligation_id",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "event_id",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "deleteObligationEvent",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "event_id",
                    "variableName": "event_id"
                },
                {
                    "kind": "Variable",
                    "name": "obligation_id",
                    "variableName": "obligation_id"
                }
            ],
            "concreteType": "DeleteObligationEvent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "event_template_id",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "result",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "errors",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "obligationsDeleteObligationEventMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "obligationsDeleteObligationEventMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "obligationsDeleteObligationEventMutation",
            "id": null,
            "text": "mutation obligationsDeleteObligationEventMutation(\n  $obligation_id: String!\n  $event_id: String!\n) {\n  deleteObligationEvent(obligation_id: $obligation_id, event_id: $event_id) {\n    event_template_id\n    result\n    description\n    errors\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b671ca857e6ea275f2cf4305d3fcf2f7';
export default node;
